export default __webpack_public_path__ + "static/media/Flying Sword.8cef0211.png";